export const LdapStatus = {
  Active: "active",
  Terminated: "terminated",
  All: "all",
};
